import { render, staticRenderFns } from "./ListConfigAddShip.vue?vue&type=template&id=761c4c08"
import script from "./ListConfigAddShip.vue?vue&type=script&lang=js"
export * from "./ListConfigAddShip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports